import { PageTitle } from '@/components/seo/page-title';
import { AdminPendingItemsScreen } from '@/features/admin/screens/admin-pending-items-screen';

export default function AdminPendingItemsRoute() {
  return (
    <>
      <PageTitle title="Pending Items" />
      <AdminPendingItemsScreen />
    </>
  );
}
